import { ChronoUnit, LocalDate } from '@js-joda/core';

const TRANSITIONAL_PERIOD = LocalDate.parse('2026-05-20');

const EARLIEST_DAYS_THRESHOLD = 30;
const LATEST_DAYS_THRESHOLD = 1;

export const getDaysLeftCount = (): number => {
   const today = LocalDate.now();
   return ChronoUnit.DAYS.between(today, TRANSITIONAL_PERIOD);
};

export const shouldDisplayMfaRequiredModal = (): boolean => {
   const daysLeft = getDaysLeftCount();

   return daysLeft <= EARLIEST_DAYS_THRESHOLD && daysLeft >= LATEST_DAYS_THRESHOLD;
};
